//@js-check
import Vue from 'vue';
import Router from 'vue-router';

import Layout from "@/layouts/Layout.vue";
import LockedLayout from "@/layouts/LockedLayout.vue";

// Pages
import Login from "@/views/login/login.vue";

// Routes
import inventoryRoutes from "./modules/inventories";
import itemRoute from "./modules/items";
import searchRoute from "./modules/search";
import adminRoute from "./modules/admin";
import rfidRoute from "./modules/rfid";

// user permissions
import { UserPermissions } from '@/utils';

import NotFound_404 from "@/views/error/404.vue";



class VueRouterEx extends Router {
  constructor(options) {
    super(options);
    const { addRoutes } = this.matcher;
    const { routes } = options;

    this.routes = routes;

    this.matcher.addRoutes = (newRoutes) => {
      this.routes.push(...newRoutes);
      addRoutes(newRoutes);
    };
  }
}


export const constantRoutes = [
  {
    path: "/authentication",
    component: LockedLayout,
    name: "Authentication",
    hidden: true,
    children: [
      {
        path: "/login",
        name: "Login",
        component: Login,
        meta: {
          title: "Вход"
        },
        hidden: true
      }
    ]
  },
  // {
  //   path: "/error",
  //   component: Layout,
  //   hidden: true,
  //   children: [
  //     {
  //       path: '404',
  //       component: NotFound_404,
  //       meta: {
  //         title: "Грешка"
  //       },
  //       hidden: true
  //     }
  //   ]
  // }
]

export const asyncRoutes = [
  inventoryRoutes,
  itemRoute,
  searchRoute,
  rfidRoute,
  adminRoute,
  
  {
    path: '*',
    component: Layout,
    hidden: true,
    meta: {
      title: "404 Страницата не е намерена",
      actions: [UserPermissions.USER, UserPermissions.ADMIN],
    },
    children: [
      {
        name: '404 Error',
        path: '',
        component: NotFound_404,
        meta: {
          title: "404 Страницата не е намерена",
          actions: [UserPermissions.USER, UserPermissions.ADMIN],
        },
        hidden: true,
      },
    ],
  },
];

Vue.use(VueRouterEx)

var _constantRoutes = [...constantRoutes];

const createRouter = () => new VueRouterEx({
  mode: 'history',
  scrollBehavior: (to) => {
    if (to.hash) {
     return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
  linkExactActiveClass: "nav-item active",
  routes: _constantRoutes
})

const router = createRouter();

export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router
